export const APP_GROUP_LINKS = {
  BASE: "/app",
};
